import DocumentLocks from '../constants/document_locks'
import DocumentVersion from './document_version';

export default class Document {
	_id;
	_fileUUID;
	_fileName;
	_fileType;
	_createdAt;
	_author;
	_version;
	_fieldValues;
	_locks;

	constructor({ id, fileUUID, fileName, fileType, createdAt, author, version = '1.0', fieldValues = {}, locks = [] }) {
		this.id = id;
		this.fileUUID = fileUUID;
		this.fileName = fileName;
		this.fileType = fileType;
		this.createdAt = createdAt;
		this.author = author;
		this.version = new DocumentVersion(version);
		this.fieldValues = fieldValues;
		this.locks = this.createLocks(locks);
	}

	isNew() {
		return !this._id && !this._fileUUID;
	}

	setFieldValue(fieldName, fieldValue) {
		let fieldValues = this._fieldValues || {};
		fieldValues[fieldName] = fieldValue;

		this.fieldValues = fieldValues;
	}

	createLocks(locksToCreate) {
		const existingDocumentLocks = Object.values(DocumentLocks);

		return locksToCreate
			.map(lock => ({ action: lock.action.toUpperCase(), owner: lock.owner }))
			.filter(lock => existingDocumentLocks.includes(lock.action));
	}

	isLockedBy(lockAction) {
		const locks = this.locks || [];
		return locks.map(lock => lock.action).includes(lockAction);
	}

	addLock(lock) {
		this.locks.push(lock);
	}

	removeLock(lockActionToDelete) {
		this.locks = this.locks.filter(lock => lock.action !== lockActionToDelete);
	}

	get checkedOut() {
		return this.locks.map(lock => lock.action).includes(DocumentLocks.EDITION);
	}

	get id() {
		return this._id;
	}

	set id(value) {
		this._id = value;
	}

	get fileUUID() {
		return this._fileUUID
	}

	set fileUUID(value) {
		this._fileUUID = value;
	}

	get fileName() {
		return this._fileName;
	}

	set fileName(value) {
		this._fileName = value;
	}

	get fileType() {
		return this._fileType;
	}

	set fileType(value) {
		this._fileType = value;
	}

	get createdAt() {
		return this._createdAt;
	}

	set createdAt(value) {
		this._createdAt = value;
	}

	get author() {
		return this._author;
	}

	set author(value) {
		this._author = value;
	}

	get version() {
		return this._version;
	}

	set version(value) {
		this._version = value;
	}

	get fieldValues() {
		return this._fieldValues;
	}

	set fieldValues(value) {
		this._fieldValues = value;
	}

	get locks() {
		return this._locks;
	}

	set locks(value) {
		this._locks = value;
	}
}
